export default __webpack_public_path__ + "static/media/36.a59e33a7.jpeg";